$(function () {

	const $form = $("#contact-form");
	if($form.length > 0) {

		const data = {};

		$(".js-input", $form).on('input', (evt) => {
			const { name, value } = evt.currentTarget;
			data[name] = value;

			let isEmpty = value === "" || value === undefined || value === null;

			if(!isEmpty && !$(evt.currentTarget).hasClass("not-empty")) {
				$(evt.currentTarget).addClass("not-empty")
			} else if(isEmpty) {
				$(evt.currentTarget).removeClass("not-empty")
			}
		});

	}

});
